<div class="checkout-login">
  <div class="column--left">
    <app-checkout-sidebar [content]="content?.fields.sidebar"></app-checkout-sidebar>
  </div>
  <div class="column--right">
    <app-sign-in [content]="content?.fields.login" (signInCompleted)="nextPage()"></app-sign-in>
  </div>
</div>
